import {
	TimeLabel,
	useDeleteTimeLabelMutation,
	useGetAllTimeLabelsLazyQuery,
	PageInfo,
} from "@repo/server-api";
import { useState } from "react";

import { DataSource } from "@repo/legacy/components/shared/lists/DataSource";
import { PaginationModel } from "@repo/legacy/components/shared/lists/PaginationModel";

export function useAllTimeLabelsDataSource(): DataSource<TimeLabel> {
	const [rows, setRows] = useState<TimeLabel[]>([]);
	const [rowCount, setRowCount] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	const [, setPageInfo] = useState<PageInfo | null>(null);
	const [searchBy, setSearchBy] = useState<string>("");
	const [pageModal, setPageModal] = useState<PaginationModel>({
		page: 0,
		pageSize: 10,
	});
	const [contactId, setContactId] = useState<string>("");

	const [deleteTimeLabel] = useDeleteTimeLabelMutation({
		onCompleted(data: { deleteTimeLabel: { boolean: boolean } }) {
			if (data.deleteTimeLabel.boolean) {
				refresh();
			}
		},
	});

	const [getTimeLabels] = useGetAllTimeLabelsLazyQuery({
		fetchPolicy: "no-cache",
		onCompleted(data: {
			allTimeLabel: {
				nodes: TimeLabel[];
				totalCount: number;
				pageInfo: PageInfo;
			} | null;
		}) {
			if (data && data.allTimeLabel) {
				setRows(data.allTimeLabel.nodes as TimeLabel[]);
				setRowCount(data.allTimeLabel.totalCount);
				setPageInfo(data.allTimeLabel.pageInfo);
				setIsLoading(false);
			}
		},
	});

	const refresh = () => {
		fetchDataForContact(pageModal, searchBy, contactId);
	};

	const fetchDataForId = (contactId: string) => {
		fetchDataForContact(pageModal, searchBy, contactId);
	};

	const fetchDataForContact = (page: PaginationModel, searchBy: string, contactId: string) => {
		setIsLoading(true);
		setSearchBy(searchBy);
		setPageModal(page);
		setContactId(contactId);
		if (contactId !== "") {
			getTimeLabels({
				variables: {
					companyId: contactId,
					first: page.pageSize,
					after: (page.pageSize * page.page).toString(),
					name: searchBy,
					onlyActive: false,
					showDeleted: false,
				},
			}).then(
				(response: {
					data: {
						allTimeLabel: {
							nodes: TimeLabel[];
							totalCount: number;
							pageInfo: PageInfo;
						} | null;
					} | null;
				}) => {
					if (response.data && response.data.allTimeLabel) {
						setRows(response.data.allTimeLabel.nodes as TimeLabel[]);
						setRowCount(response.data.allTimeLabel.totalCount);
						setPageInfo(response.data.allTimeLabel.pageInfo);
						setIsLoading(false);
					}
				},
			);
		}
	};

	const deleteDataForTimeLabel = (id: string, version: number) => {
		deleteTimeLabel({ variables: { id, version } });
	};

	return {
		rows,
		rowCount,
		isLoading,
		fetchDataForContact,
		deleteDataForTimeLabel,
		refresh,
		fetchDataForId,
	};
}
